import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useFormik } from "formik";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import AxiosMain from "../../components/layout/AxiosMain";
import LoaderScreen from "../../components/layout/LoaderScreen";
import {
  AppAPiUrl,
  appModelPermission,
  appModelType,
} from "../../configs/appData";
import TranslationGetHOC from "../../components/layout/TranslationGetHOC";
import AppPermissionHOC from "../../components/layout/AppPermissionHOC";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";


const SendMessageComponentReady = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [iComponetTranslate, setICTranslation] = useState([]);
  const [isTransLoaded, setLoaded] = useState(false);
  const { appCountry } = useSelector((state: RootState) => state.appState);
  const userDetails = useSelector(
    (state: RootState) => state.authState.userState
  );
  const [dropDownMessages, setDropDownMessages] = useState([]);
  const t = (name: string) => {
    const ifExist: any = iComponetTranslate.filter(
      (item: any) => item.label === name
    );
    if (ifExist.length > 0) {
      return ifExist[0].value
        ? ifExist[0].value
        : `No translate found (${ifExist[0].label})`;
    }
    return `No key found (${name})`;
  };
  const getDropDownData = async ({ url, saveData }: any) => {
    AxiosMain.get(url)
      .then((res) => {
        if (res.status === 200 && res.data.count > 0) {
          if (userDetails.id === 1) {
            saveData(res.data.results);
          } else {
            const userrldata = res.data.results.filter(
              (item: any) => item.name !== "Supervisor"
            );
            saveData(userrldata);
          }
        }
      })
      .catch((e) => {
        console.log("Something went wrong while fetching data");
      });
  };

  const formSwalTranslation = {
    formSwalTitle: t("AreYouWanttoSave"),
    formSwalText: t("Youwontbeabletorevertthis"),
    fomrSwalCancel: t("Cancel"),
    formSwalSaved: t("YesSavedit"),
    formSwalDataSaved: t("YourDatahasbeensaved"),
    formSwalSubmited: t("Submited"),
    formSwalWrong: t("SomethingWentWrong"),
  };

  const formik = useFormik({
    initialValues: {
      select_message: "",
      user: "",
    },
    // validationSchema: AddUserSchema,
    onSubmit: (values) => {
      setIsLoading(true);
      AxiosMain.post(AppAPiUrl.Messages, values)
        .then((res) => {
          if (res.status === 201) {
            Swal.fire({
              title: formSwalTranslation.formSwalSubmited,
              text: formSwalTranslation.formSwalDataSaved,
              icon: "success",
            });
            setIsLoading(false);
            formik.resetForm();
            props.handleClose();
          }
        })
        .catch((e) => {
          setIsLoading(false);
          console.log("error ", e);
          const { response } = e;
          if (response.status === 400) {
            const { email } = response.data;
            if (email.length > 0) {
              Swal.fire({
                title: "Error",
                text: email[0],
                icon: "error",
              });
            }
          } else {
            Swal.fire({
              title: "Error",
              text: formSwalTranslation.formSwalWrong,
              icon: "error",
            });
          }
        });
    },
  });

  useEffect(() => {
    const { translateDataft } = props;
    const newCode = appCountry.toLocaleLowerCase();
    if (translateDataft && translateDataft.hasOwnProperty(`${newCode}`)) {
        setICTranslation(translateDataft[`${newCode}`]);
        setTimeout(() => {
            setLoaded(true);
        }, 100);
    }
    else {
        setICTranslation([]);
        setLoaded(true);
    }
}, [props, appCountry]);

  return (
    <>
      <div className="cm-user-tabs-wrapper  cm-global-tabs-wrapper">
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent={"center"}
        >
          <Box
            className="fw-600"
            sx={{ color: "#012445", fontSize: "40px;", lineHeight: "normal" }}
          >
            {t("sendwelcomemessage")}
          </Box>
        </Stack>
        <div className="cm-user-form-wrap" style={{ marginTop: "10px" }}>
          {isTransLoaded && isLoading ? (
            <LoaderScreen />
          ) : (
            <Box sx={{ width: "100%" }}>
              <Box>
                <form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Grid container spacing={5} sx={{ paddingTop: "0" }}>
                      <Grid item md={12} sm={12} xs={12}>
                        <Box className="cm-form-inner-fields">
                          <Box className="form-mb-30">
                            <Box sx={{ flexGrow: 1 }}>
                              <Grid container spacing={3}>
                                <Grid item xs={12}>
                                  <Box sx={{ width: "100%" }}>
                                    <div className="form-lable-name">
                                      {t("selectmessage")}
                                    </div>
                                    <FormControl sx={{ width: "100%" }}>
                                    <InputLabel id="demo-simple-select-label">Select</InputLabel>
                                      <Select
                                        className="form-select-pad"
                                        id="select_message"
                                        name="select_message"
                                        label="Select"
                                        value={formik.values.select_message}
                                        onChange={formik.handleChange}
                                      >
                                        <MenuItem value="">
                                          Choose Option
                                        </MenuItem>
                                        {dropDownMessages.length > 0 &&
                                          dropDownMessages.map((val: any) => (
                                            <MenuItem
                                              key={`user-carrier-data--${val.id}`}
                                              value={val.id}
                                            >
                                              {val.name}
                                            </MenuItem>
                                          ))}
                                      </Select>
                                    </FormControl>
                                    {formik.errors.select_message &&
                                      formik.touched.select_message && (
                                        <p className="cm-form-error">
                                          {formik.errors.select_message}
                                        </p>
                                      )}
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </form>
              </Box>
            </Box>
          )}
        </div>
      </div>
    </>
  );
};
function SendMessage(props: any) {
  const { isAllow } = props;
  const dependency = { require: ["Sidebar"] };
  const MainComponent = TranslationGetHOC(
    SendMessageComponentReady,
    "users",
    isAllow,
    props,
    dependency
  );
  return isAllow ? <MainComponent /> : <LoaderScreen msg="Loading ..." />;
}
export default AppPermissionHOC(
  SendMessage,
  appModelPermission.SETERAUSER,
  appModelType.CREATE
);
